import { useNavigate, useParams } from 'react-router-dom';
import { useAppContext } from '../FirebaseAppContext';
import './DetailPages.css';

export default function ServiceDetail() {
  const { serviceId } = useParams<{ serviceId: string }>();
  const navigate = useNavigate();
  const { state, serviceOperations } = useAppContext();
  const service = state.services.find(s => s.id === serviceId);
  const car = service ? state.cars.find(c => c.id === service.carId) : undefined;

  if (!service) {
    return (
      <div className="detail-page">
        <div className="detail-card detail-list">
          <p>Service log not found</p>
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/services')}>Back to Services</button>
        </div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this service log?')) {
      try {
        await serviceOperations.delete(service.id);
        navigate('/services');
      } catch (err) {
        alert('Failed to delete service log: ' + (err as Error).message);
      }
    }
  };

  return (
    <div className="detail-page">
      <div className="detail-header">
        <button type="button" className="btn btn-secondary" onClick={() => navigate('/services')}>← Back</button>
        <h1 className="detail-title">Service Log Details</h1>
        <button type="button" className="btn btn-secondary" onClick={() => navigate(`/services/${service.id}/edit`)}>Edit</button>
        <button type="button" className="btn btn-primary" onClick={handleDelete}>
          Delete
        </button>
      </div>

      <div className="detail-card detail-list">
        <div className="detail-item"><span className="detail-item-label">Car</span><span className="detail-item-value">{car ? `${car.year} ${car.make} ${car.model} (${car.licensePlate})` : 'Unknown'}</span></div>
        <div className="detail-item"><span className="detail-item-label">Date</span><span className="detail-item-value">{new Date(service.date).toLocaleDateString()}</span></div>
        <div className="detail-item"><span className="detail-item-label">Description</span><span className="detail-item-value">{service.description}</span></div>
        <div className="detail-item"><span className="detail-item-label">Odometer</span><span className="detail-item-value">{service.mileage.toLocaleString()} km</span></div>
        {service.nextServiceKm && (
          <div className="detail-item"><span className="detail-item-label">Next Service at</span><span className="detail-item-value">{service.nextServiceKm.toLocaleString()} km</span></div>
        )}
        {service.nextServiceDate && (
          <div className="detail-item"><span className="detail-item-label">Next Service Date</span><span className="detail-item-value">{new Date(service.nextServiceDate).toLocaleDateString()}</span></div>
        )}
        {service.issuesFound && (
          <div className="detail-item">
            <span className="detail-item-label">Issues Found</span>
            <div className="detail-item-block">{service.issuesFound}</div>
          </div>
        )}
      </div>
    </div>
  );
}

